import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toCanvas } from 'qrcode';
import { VisitCardStatus } from '../../services/visit-card.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-visit-card-image',
    templateUrl: './visit-card-image.component.html',
    styleUrls: ['./visit-card-image.component.scss'],
    standalone: false
})
export class VisitCardImageComponent implements OnInit, OnDestroy, AfterViewChecked {

    constructor(private http:HttpClient, private localizationSevice:LocalizationService, private cdRef: ChangeDetectorRef) { }

    @Input() visitCardStatus:VisitCardStatus;
    @Input() noImage:boolean;

    @Output() isReady = new EventEmitter<void>()

    cardImage:HTMLImageElement = null;

    private _blobURL:string = null;

    private _fonts = {
        code: {
            family: 'Roboto Mono Visit Card',
            url: 'https://fonts.gstatic.com/s/robotomono/v31/L0x5DF4xlVMF-BfR8bXMIjhLq38.woff2',
            style: 'bold 40px',
        },
        date: {
            family: 'Inria Sans Visit Card',
            url: 'https://fonts.gstatic.com/s/inriasans/v15/ptRMTiqXYfZMCOiVj9kQ1On4KA.woff2',
            style: '32px'
        }

    }

    private _fontsLoaded = false;

    ngOnInit(): void {
        this.http.get('assets/images/visit-card.png', { responseType: 'arraybuffer' }).subscribe((data) => {
            let _blob = new Blob([data])

            let _image = new Image()
            _image.addEventListener('load', () => {
                this.cardImage = _image
                this.cdRef.markForCheck()
            })
            
            this._blobURL = URL.createObjectURL(_blob);
            _image.src = this._blobURL;
        })

        let _promises:Array<Promise<any>> = []

        for(let i in this._fonts) {
            _promises.push(new Promise<void>((resolve) => {
                let _font = new FontFace(this._fonts[i].family, 'url(' + this._fonts[i].url + ')');
    
                _font.load().then(() => {
                    document.fonts.add(_font);
                    console.log(_font)
                    resolve()
                })
            }))
        }

        Promise.all(_promises).then(() => {
            this._fontsLoaded = true;
            this.cdRef.markForCheck()
        });
    }

    ngOnDestroy(): void {
        if(this._blobURL) URL.revokeObjectURL(this._blobURL)
    }

    private _drawCard = false;

    ngOnChanges() {
        this._drawCard = false;

        if(this.visitCardStatus?.status == 'confirmed') this._drawCard = true;
    }
    
    getVisitCardStatusDisplay(status:string) {
        switch(status) {
            case 'confirmed': return { color: 'success', icon: 'fa-check' };
            case 'canceled': return { color: 'danger', icon: 'fa-times' };
            default: return { color: 'secondary', icon: 'fa-ellipsis' };
        }
    }

    @ViewChild('cardCanvasElement') cardCanvasElement:ElementRef

    ngAfterViewChecked(): void {
        if(this._drawCard && this.cardCanvasElement != null && this.cardImage != null && this._fontsLoaded) {
            this._drawCard = false;

            let _canvas:HTMLCanvasElement = this.cardCanvasElement.nativeElement;
            _canvas.width = this.cardImage.width;
            _canvas.height = this.cardImage.height;

            let _ctx = _canvas.getContext('2d')

            _ctx.drawImage(this.cardImage, 0, 0)

            let _scale = this.cardImage.width / 1189

            _ctx.scale(_scale, _scale) // applico uno scale se la dimensione dell'immagine è diversa da quella che mi aspetto, così le coordinate seguenti saranno posizionate correttamente

            // cancello i dati presenti

            _ctx.fillStyle = 'white'

            _ctx.fillRect(82, 272, 226, 226) // QR
            _ctx.fillRect(479, 35, 317, 32) // testo codice
            _ctx.fillRect(857, 35, 289, 32) // testo data

            // disegno il QR

            let _qr:HTMLCanvasElement = document.createElement('canvas')

            toCanvas(_qr, this.visitCardStatus.code, { width: 224, margin: 0 })

            _ctx.drawImage(_qr, 83, 273)

            _ctx.fillStyle = '#a21e43'
            _ctx.textAlign = 'center'
            _ctx.textBaseline = 'middle'
            
            // scrivo il testo codice

            _ctx.font = this._fonts.code.style + ' ' + this._fonts.code.family
            _ctx.fillText(this.visitCardStatus.code, 638, 60)

            // scrivo il testo data

            _ctx.font = this._fonts.date.style + ' ' + this._fonts.date.family
            _ctx.fillText(this.localizationSevice.translate('visit-card-image.visit-card-valid-to') + ' ' + this.localizationSevice.format.date(this.visitCardStatus.to), 990, 60)

            this.isReady.emit()
        }
    }
}

